jQuery( document ).ready(function($) {

  if($('.account').length > 0) {
    
    if ( ($( ".account_orderHeader div:last-of-type()" ).text()) == 'Actions' ) {
      $( ".account_orderHeader div:last-of-type()" ).text('Facture')
    }

  }
});

